// Icelandic translations
export const is: Record<string, string> = {
  'menu.dashboard': 'Stjórnborð',
  'menu.customers': 'Viðskiptavinir',
  'menu.products': 'Vörur',
  'menu.users': 'Notendur',
  'menu.settings': 'Stillingar',
  'menu.logout': 'Skrá út',
  'dashboard.title': 'Stjórnborð',
  'dashboard.newOrder': 'Ný pöntun',
  'order.title': 'Ný pöntun',
  'order.customer': 'Viðskiptavinur',
  'order.products': 'Vörur',
  'order.total': 'Samtals',
  'users.title': 'Notendur',
  'users.name': 'Nafn',
  'users.email': 'Netfang',
  'common.yes': 'Já',
  'common.no': 'Nei',
  'common.cancel': 'Hætta við',
  'common.save': 'Vista',
  'common.search': 'Leita',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Innskrá',
  'login.welcome': 'Velkomin, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Netfang',
  'signup.phone': 'Sími',
  'menu.reportsAndAccounting': 'Skýrslur og bókhald',
  'menu.systemAndCommunication': 'Kerfi og samskipti',
};